
import React, { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";

const slides = [
  {
    image: "/assets/home_06.jpg",
    heading: "Commercial Catering\nDesign & Installation",
    description: "We transform your vision into reality with innovative catering solutions."
  },
  {
    image: "/assets/home_01.jpg", 
    heading: "Innovative Solutions From \nDesign To Delivery",
    description: "Seamlessly guiding your kitchen project — from creative design concepts to final equipment delivery and setup."
  },
  {
    image: "/assets/kitchenimg04.png",
    heading: "Professional Support For \nThe Foodservice Industry", 
    description: "Expert assistance at every step — empowering foodservice businesses with reliable, industry-grade kitchen solutions."
  }
];

export default function HomeContent() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const contentRef = useRef(null);
  const imageRefs = useRef([]);

  // Auto-change background image every 5 seconds with GSAP animation
  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;

      // Fade out current image
      gsap.to(imageRefs.current[currentIndex], {
        opacity: 0,
        scale: 1.1,
        duration: 1,
        ease: "power2.out",
      });

      // Fade in next image
      gsap.to(imageRefs.current[nextIndex], {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: "power2.out",
        onComplete: () => setCurrentIndex(nextIndex),
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  // GSAP Animation for content whenever slide changes
  useEffect(() => {
    const content = contentRef.current;

    // Animate content in
    gsap.fromTo(
      content.children,
      {
        y: 60,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1.2,
        delay: 0.3,
        ease: "power4.out",
        stagger: 0.2,
      }
    );
  }, [currentIndex]); // Re-run animation when slide changes

  return (
    <div className="relative w-full h-screen overflow-hidden font-sans flex items-center justify-center p-4 sm:p-6 lg:p-8">
      {/* Bordered container for the carousel */}
      <div className="relative md:mt-8 w-full h-[80vh] sm:h-[60vh] lg:h-[80vh] overflow-hidden shadow-lg">
        {/* Background images with gradient overlay */}
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              ref={(el) => (imageRefs.current[index] = el)}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentIndex ? "opacity-100 scale-100" : "opacity-0 scale-110"
              }`}
            >
              <img
                src={slide.image}
                alt={`Background ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40" /> {/* Gradient overlay */}
            </div>
          ))}
        </div>

        {/* Content */}
        <div className="relative h-full flex items-end justify-start px-4 sm:px-6 lg:px-8 pb-8">
          <div
            ref={contentRef}
            className="text-left max-w-md backdrop-filter backdrop-blur-[2px] bg-black bg-opacity-30 p-6 rounded-lg"
          >
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extralight text-white mb-6 tracking-tight">
              {slides[currentIndex].heading.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < slides[currentIndex].heading.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-[#ffffffc4] mb-8 leading-relaxed">
              {slides[currentIndex].description}
            </p>

            {/* <button className="mt-2 px-8 py-3 bg-indigo-800 text-white text-lg font-semibold rounded-full hover:bg-indigo-900 hover:scale-105 transition-all duration-300 ease-out shadow-lg hover:shadow-xl">
              Let's Get Started
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}